import apiClient from './apiClient';
import type { ApiResponse, ConsultationDiagnosis } from '../types/api';

export interface CreateConsultationDiagnosisRequest {
    consultation_id: number;
    diagnosis_id: number;
    diagnosis_type: string;
    observations?: string;
}

export interface UpdateConsultationDiagnosisRequest {
    diagnosis_type?: string;
    diagnosis_order?: number;
    observations?: string;
}

export const consultationDiagnosisService = {
    async getByConsultation(consultationId: number): Promise<ConsultationDiagnosis[]> {
        const response = await apiClient.get<ApiResponse<ConsultationDiagnosis[]>>(
            `/consultation-diagnoses?consultation_id=${consultationId}`
        );
        return response.data.data;
    },

    async create(data: CreateConsultationDiagnosisRequest): Promise<ConsultationDiagnosis> {
        const response = await apiClient.post<ApiResponse<ConsultationDiagnosis>>(
            '/consultation-diagnoses',
            data
        );
        return response.data.data;
    },

    async update(id: number, data: UpdateConsultationDiagnosisRequest): Promise<ConsultationDiagnosis> {
        const response = await apiClient.put<ApiResponse<ConsultationDiagnosis>>(
            `/consultation-diagnoses/${id}`,
            data
        );
        return response.data.data;
    },

    async delete(id: number): Promise<void> {
        await apiClient.delete(`/consultation-diagnoses/${id}`);
    },
};

export default consultationDiagnosisService;
